import { render, staticRenderFns } from "./AppStrategyidSetting.vue?vue&type=template&id=f13db75e&scoped=true"
import script from "./AppStrategyidSetting.vue?vue&type=script&lang=js"
export * from "./AppStrategyidSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13db75e",
  null
  
)

export default component.exports